import { render } from "./tw-dialog.vue?vue&type=template&id=56247146"
import script from "./tw-dialog.vue?vue&type=script&lang=js"
export * from "./tw-dialog.vue?vue&type=script&lang=js"
script.render = render

export default script